(() => {
  function initialize(root) {
    if (root.dataset.sfReady === 'true' || !window.SofuriAdoptionMaps) return;
    root.dataset.sfReady = 'true';
    const q = selector => root.querySelector(selector);
    const maps = window.SofuriAdoptionMaps;
    const country = q('#sf-country');
    const region = q('#sf-region');
    const name = q('#sf-name');
    const date = q('#sf-date');
    let pet = 'Dog';
    const today = new Date();
    date.max = [today.getFullYear(), String(today.getMonth()+1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-');
    function render() {
      const selected = maps[country.value].find(item => item.name === region.value);
      q('#sf-map-path').setAttribute('d', selected.path);
      q('.sf-map').setAttribute('aria-label', selected.name + ' outline');
      q('#sf-label-name').textContent = name.value.trim() || 'Your pet';
      let labelDate = 'Choose a date';
      if (date.value && date.checkValidity()) {
        const parts = date.value.split('-').map(Number);
        labelDate = new Intl.DateTimeFormat('en-US', { month:'short', day:'numeric', year:'numeric', timeZone:'UTC' })
          .format(new Date(Date.UTC(parts[0], parts[1]-1, parts[2])));
      }
      q('#sf-label-date').textContent = 'Adopted \u00b7 ' + labelDate;
      q('#sf-location-label').textContent = selected.name + ' \u00b7 ' + pet;
      q('.sf-paw').classList.toggle('is-cat', pet === 'Cat');
    }
    function setRegions() {
      region.replaceChildren(...maps[country.value].map(item => new Option(item.name, item.name)));
      region.value = country.value === 'us' ? 'California' : 'Ontario';
      q('#sf-region-title').textContent = country.value === 'us' ? 'State' : 'Province / territory';
      render();
    }
    country.addEventListener('change', setRegions);
    region.addEventListener('change', render);
    name.addEventListener('input', render);
    date.addEventListener('input', render);
    root.querySelectorAll('[data-pet]').forEach(button => button.addEventListener('click', () => {
      pet = button.dataset.pet;
      root.querySelectorAll('[data-pet]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      render();
    }));
    setRegions();
  }
  function scan(container) {
    if (container.matches?.('[data-sf-adoption]')) initialize(container);
    container.querySelectorAll('[data-sf-adoption]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

